import { redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { trackEvent } from "@/lib/audit";

/**
 * Hard gate for enterprise-only public routes (/partners, /partners/login,
 * /corporate-access). Normal users must never see these pages.
 *
 * Allowed when:
 *   - Supabase session + is_superadmin RPC returns true, OR
 *   - A localStorage `vs:partner_session` blob exists (legacy partner login).
 *
 * Otherwise: redirect to `/` (home).
 */
export async function requireEnterpriseAccess(pathname: string): Promise<void> {
  if (typeof window === "undefined") return;
  let allowed = false;
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    if (sessionData.session) {
      const { data } = await supabase.rpc("is_superadmin");
      if (data) allowed = true;
    }
  } catch { /* noop */ }
  if (!allowed) {
    try {
      if (window.localStorage.getItem("vs:partner_session")) allowed = true;
    } catch { /* noop */ }
  }
  if (!allowed) {
    void trackEvent("tenant_isolation_enforced", {
      pathname,
      reason: "enterprise_route_blocked",
      enforced_by: "enterprise_gate",
    });
    throw redirect({ to: "/" });
  }
}